import { Reveal } from "../../lib/motion";
import { PROCESS } from "../../data/site";

export const Manifesto = () => (
  <section id="approach" data-testid="approach-section" className="py-24 lg:py-32 bg-[#0d1424] relative">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        {/* Sticky heading */}
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <p className="overline mb-4">The approach</p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[var(--text)] leading-[1.02]">
                Four chapters of a <span className="text-gold italic">calmer</span> financial life.
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 text-white/60 text-base leading-relaxed max-w-md">
                No noise, no market-timing gambles. Just a repeatable, transparent process built
                to compound your wealth and your peace of mind.
              </p>
            </Reveal>
          </div>
        </div>

        {/* Chapters */}
        <div className="lg:col-span-7 flex flex-col">
          {PROCESS.map((p, i) => (
            <Reveal
              key={p.n}
              delay={i * 0.05}
              className={`py-10 ${i !== PROCESS.length - 1 ? "border-b border-white/10" : ""}`}
            >
              <div data-testid={`process-${p.n}`} className="flex gap-6 lg:gap-10 items-start group">
                <span className="font-display text-5xl lg:text-6xl text-white/15 group-hover:text-gold transition-colors duration-500 leading-none">
                  {p.n}
                </span>
                <div className="pt-1">
                  <h3 className="font-display text-2xl lg:text-3xl text-[var(--text)] mb-3">{p.title}</h3>
                  <p className="text-white/60 text-base leading-relaxed max-w-lg">{p.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
